import connection from "../connection";

export const prepareCheckout = async (registrationId, registrationCost, isLeague) =>
   connection.post(`v1/registrations/${registrationId}/prepare_checkout`, {registration_cost: registrationCost, is_league: isLeague});

export const getDiscount = async (registration, isLeague) =>
   connection.get(`v1/registrations/${registration}/get_discount`, {is_league: isLeague});

export const getPaymentData = async (resourcePath, registration, isLeague) =>
   connection.post('v1/registrations/get_payment_data', {resource_path: resourcePath, registration: registration, is_league: isLeague});

export const processPayment = async () =>
   connection.post('v1/registrations/process_payment');

export const getUnconcludedPaidRegistrations = async =>
   connection.get('v1/registrations/unconcluded_paid_registrations');

export const getUnconcludedUnpaidRegistrations = async =>
   connection.get('v1/registrations/unconcluded_unpaid_registrations');

export const getRegistrationDetails = async id =>
   connection.get(`v1/registrations/${id}/registration_details`);

export const getTournamentRegistrations = async =>
   connection.get('v1/tournament_registrations');

export const getTournamentRegistrationDetails = async id =>
   connection.get(`v1/tournament_registrations/${id}/details`);

export const changeOffersRegistration = async (id, params) =>
   connection.post(`v1/registrations/${id}/change_offers`, params);